export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/ac478f259eebce517c6cc06e4306b00d.svg";